module.exports = __webpack_public_path__ + "img/08.111c02dc.jpg";